module.exports = {"id":"201041","name":"Lionel Carole","rating":"71","photo":"./data/images/photos/2/201041.png","club":{"name":"Séville FC","logo":"./data/images/clubs/SevilleFC.png"},"positions":["DG","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LionelCarole0.json
// module id = 2514
// module chunks = 0